module.exports = __webpack_public_path__ + "img/woman_body.28b35193.png";